'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _dec3, _class, _class2, _temp;

var _Link = require('components/Link/Link');

var _Link2 = _interopRequireDefault(_Link);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _NotFound = require('./NotFound.scss');

var _NotFound2 = _interopRequireDefault(_NotFound);

var _reactIntl = require('react-intl');

var _reactRedux = require('react-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _inspirations = require('redux/modules/inspirations');

var InspirationsAction = _interopRequireWildcard(_inspirations);

var _suggestion = require('redux/modules/suggestion');

var _SearchBox = require('components/Nav/SearchBox');

var _SearchBox2 = _interopRequireDefault(_SearchBox);

var _media = require('utils/media');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  NotFound: {
    displayName: 'NotFound'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/containers/NotFound/NotFound.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

var NotFound = _wrapComponent('NotFound')((_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch;

    var promises = [];
    promises.push(dispatch((0, _inspirations.loadRandomInspirations)()));
    promises.push(dispatch((0, _suggestion.loadKeywords)()));
    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    randomInspirations: state.inspirations.randomInspirations,
    locale: state.language.locale
  };
}, InspirationsAction), _dec3 = (0, _reactCssModules2.default)(_NotFound2.default), _dec(_class = _dec2(_class = _dec3(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(NotFound, _Component);

  function NotFound() {
    (0, _classCallCheck3.default)(this, NotFound);
    return (0, _possibleConstructorReturn3.default)(this, (NotFound.__proto__ || (0, _getPrototypeOf2.default)(NotFound)).apply(this, arguments));
  }

  (0, _createClass3.default)(NotFound, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          randomInspirations = _props.randomInspirations,
          locale = _props.locale;

      return _react3.default.createElement(
        'div',
        { styleName: 'main-container' },
        _react3.default.createElement(_reactHelmet2.default, { title: '404 Not Found | ' }),
        _react3.default.createElement(
          'div',
          { styleName: 'inner' },
          _react3.default.createElement('img', { src: require('./404.png'), styleName: 'notfound-image', alt: 'Not found image' }),
          _react3.default.createElement(
            'h1',
            null,
            _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'not_found.header' })
          ),
          _react3.default.createElement(
            'div',
            { styleName: 'search-container' },
            _react3.default.createElement(_SearchBox2.default, { filterStyle: true })
          ),
          _react3.default.createElement(
            'p',
            null,
            _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'not_found.description_1',
              values: {
                location: locale === 'th' ? _react3.default.createElement(
                  _Link2.default,
                  { to: '/inspirations', className: _NotFound2.default.link },
                  '\u0E42\u0E15\u0E40\u0E01\u0E35\u0E22\u0E27'
                ) : _react3.default.createElement(
                  _Link2.default,
                  { to: '/to/Bangkok', className: _NotFound2.default.link },
                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'not_found.description_1.bangkok' })
                )
              }
            })
          ),
          _react3.default.createElement(
            'p',
            null,
            _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'not_found.description_2' })
          ),
          _react3.default.createElement(
            'div',
            { styleName: 'inspirations-container' },
            randomInspirations.map(function (insp) {
              if (insp.is_public) {
                return _react3.default.createElement(
                  _Link2.default,
                  { key: insp._id, styleName: 'inspiration-card', to: '/inspiration/' + insp.slug },
                  _react3.default.createElement(
                    'div',
                    { styleName: 'card-image', style: (0, _media.path)(insp.thumbnail_image, 'coverTripCard', true) },
                    _react3.default.createElement(
                      'div',
                      { styleName: 'card-shadow' },
                      _react3.default.createElement(
                        'h2',
                        null,
                        insp.name
                      )
                    )
                  ),
                  _react3.default.createElement(
                    'div',
                    { styleName: 'card-detail' },
                    _react3.default.createElement(
                      'h3',
                      { styleName: 'inspiration-name' },
                      insp.name
                    ),
                    _react3.default.createElement(
                      'p',
                      { styleName: 'inspiration-description' },
                      insp.description
                    )
                  ),
                  _react3.default.createElement(
                    'div',
                    { styleName: 'see-more-container' },
                    _react3.default.createElement(
                      'span',
                      null,
                      'See more'
                    )
                  )
                );
              }
            })
          )
        )
      );
    }
  }]);
  return NotFound;
}(_react2.Component), _class2.propTypes = {
  randomInspirations: _react2.PropTypes.array,
  locale: _react2.PropTypes.string
}, _temp)) || _class) || _class) || _class));

exports.default = NotFound;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/NotFound/NotFound.js
// module id = 1683
// module chunks = 35